<template>
  <f7-page :page-content="false">
    <f7-navbar>
      <f7-nav-left>
        <f7-link @click.stop="$f7router.back()">&lt; {{ $t('atras') }}</f7-link>
      </f7-nav-left>
      <f7-nav-title sliding>
        Planificación
        <span v-if="rformData && rformData.codigoExpediente"> - {{ rformData.codigoExpediente }}</span>
      </f7-nav-title>
    </f7-navbar>
    <f7-page-content>
      <r-form
        ref="rform"
        :itemId="id"
        :readonly="readonly"
        :dbAdapter="Planificacion"
        @loadItem="loadItem"
      >
        <template v-slot:default="{ rform }">

          <!-- CARD: Datos generales (campos primer nivel) -->
          <f7-card class="padding-vertical-half padding-right">
            <f7-card-header>Datos generales</f7-card-header>
            <f7-card-content>
              <f7-row no-gap class="list list-form no-hairlines">
                <f7-col width="100" medium="50">
                  <ul>
                    <r-input outline floating-label label="Cod. Expediente"
                      :form="rform" name="codigoExpediente"></r-input>
                    <r-input outline floating-label label="Nº Pedido"
                      :form="rform" name="numeroPedido"></r-input>
                    <r-input outline floating-label label="Nº Línea"
                      :form="rform" name="numLinea"></r-input>
                    <r-input outline floating-label label="Nº Oferta"
                      :form="rform" name="numeroOferta"></r-input>
                    <r-input outline floating-label label="Fecha Inicio" type="datepicker"
                      :form="rform" name="horaInicio"
                      :calendar-params="{ dateFormat: 'dd/mm/yyyy hh::mm', timePicker: true }"></r-input>
                    <r-input outline floating-label label="Tipo"
                      :form="rform" name="tipo"></r-input>
                    <r-input outline floating-label label="Estado"
                      :form="rform" name="estado"></r-input>
                    <r-input outline floating-label label="Tiempo Estimado (min)"
                      :form="rform" name="tiempoEstimadoCampo"></r-input>
                  </ul>
                </f7-col>
                <f7-col width="100" medium="50">
                  <ul>
                    <r-input outline floating-label label="RAE"
                      :form="rform" name="rae"></r-input>
                    <r-input outline floating-label label="Titular"
                      :form="rform" name="titular"></r-input>
                    <r-input outline floating-label label="Contacto"
                      :form="rform" name="contacto"></r-input>
                    <r-input outline floating-label label="Teléfono"
                      :form="rform" name="telefono1"></r-input>
                    <r-input outline floating-label label="Empleado Planificador"
                      :form="rform" name="empleadoPlanificador"></r-input>
                    <r-input outline floating-label label="Fecha Planificación" type="datepicker"
                      :form="rform" name="fechaPlanificacion"
                      :calendar-params="{ dateFormat: 'dd/mm/yyyy hh::mm', timePicker: true }"></r-input>
                    <r-input outline floating-label label="Creado por"
                      :form="rform" name="creationUserName"></r-input>
                    <r-input outline floating-label label="Fecha creación" type="datepicker"
                      :form="rform" name="creationDate"
                      :calendar-params="{ dateFormat: 'dd/mm/yyyy hh::mm', timePicker: true }"></r-input>
                  </ul>
                </f7-col>
              </f7-row>

              <f7-row no-gap class="list list-form no-hairlines">
                <f7-col width="100">
                  <ul>
                    <r-input outline floating-label label="Comentarios Planificación" type="textarea"
                      :form="rform" name="comentariosPlanificacion"></r-input>
                    <r-input outline floating-label label="Comentarios Línea" type="textarea"
                      :form="rform" name="comentariosLinea"></r-input>
                    <r-input outline floating-label label="Trabajo a realizar" type="textarea"
                      :form="rform" name="trabajoRealizar"></r-input>
                  </ul>
                </f7-col>
              </f7-row>
            </f7-card-content>
          </f7-card>

          <!-- CARD: Cliente (objeto cliente) -->
          <f7-card class="padding-vertical-half padding-right">
            <f7-card-header>Cliente</f7-card-header>
            <f7-card-content>
              <f7-row no-gap class="list list-form no-hairlines">
                <f7-col width="100" medium="50">
                  <ul>
                    <r-input outline floating-label label="Razón social"
                      :form="rform" name="cliente.razonSocial"></r-input>
                  </ul>
                </f7-col>
                <f7-col width="100" medium="50">
                  <ul>
                    <r-input outline floating-label label="Código"
                      :form="rform" name="cliente.codigo"></r-input>
                  </ul>
                </f7-col>
              </f7-row>
            </f7-card-content>
          </f7-card>

          <!-- CARD: Servicio (objeto servicio) -->
          <f7-card class="padding-vertical-half padding-right">
            <f7-card-header>Servicio</f7-card-header>
            <f7-card-content>
              <f7-row no-gap class="list list-form no-hairlines">
                <f7-col width="100">
                  <ul>
                    <r-input outline floating-label label="Nombre"
                      :form="rform" name="servicio.nombre"></r-input>
                  </ul>
                </f7-col>
              </f7-row>
            </f7-card-content>
          </f7-card>

          <!-- CARD: Formato (objeto formato) -->
          <f7-card class="padding-vertical-half padding-right">
            <f7-card-header>Formato</f7-card-header>
            <f7-card-content>
              <f7-row no-gap class="list list-form no-hairlines">
                <f7-col width="100">
                  <ul>
                    <r-input outline floating-label label="Nombre"
                      :form="rform" name="formato.nombre"></r-input>
                  </ul>
                </f7-col>
              </f7-row>
            </f7-card-content>
          </f7-card>

          <!-- CARD: Dirección de inspección (objeto direccionInspeccion) -->
          <f7-card class="padding-vertical-half padding-right">
            <f7-card-header>Dirección de inspección</f7-card-header>
            <f7-card-content>
              <f7-row no-gap class="list list-form no-hairlines">
                <f7-col width="100" medium="50">
                  <ul>
                    <r-input outline floating-label label="Población"
                      :form="rform" name="direccionInspeccion.poblacion"></r-input>
                    <r-input outline floating-label label="Provincia"
                      :form="rform" name="direccionInspeccion.provincia"></r-input>
                  </ul>
                </f7-col>
                <f7-col width="100" medium="50">
                  <ul>
                    <r-input outline floating-label label="Dirección"
                      :form="rform" name="direccionInspeccion.direccion"></r-input>
                    <r-input outline floating-label label="Código Postal"
                      :form="rform" name="direccionInspeccion.cp"></r-input>
                  </ul>
                </f7-col>
              </f7-row>
            </f7-card-content>
          </f7-card>

          <!-- CARD: Inspectores (array de objetos InspectorRolEMO) -->
          <f7-card class="padding-vertical-half padding-right">
            <f7-card-header>Inspectores</f7-card-header>
            <f7-card-content>
              <div class="inspectores-chips">
                <f7-chip
                  v-for="(insp, i) in (rform.formData && rform.formData.inspectores) || []"
                  :key="'insp-'+i"
                  :text="insp.username + (insp.nombre ? ' - ' + insp.nombre : '')"
                  media-bg-color="blue"
                  :deleteable="!readonly"
                  @delete="removeInspector(i)"
                >
                  <template v-slot:media>
                    <i class="icon f7-icons">person</i>
                  </template>
                </f7-chip>
                <span
                  v-if="!rform.formData || !rform.formData.inspectores || !rform.formData.inspectores.length"
                  class="text-color-gray"
                >Sin inspectores asignados</span>
              </div>
            </f7-card-content>
          </f7-card>

        </template>
      </r-form>
    </f7-page-content>
  </f7-page>
</template>
<style scoped>
  .inspectores-chips {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    padding-top: 4px;
    padding-bottom: 4px;
  }
</style>
<script>
import rForm from "./../../components/rForm.vue";
import rInput from "./../../components/rInput.vue";
import { f7Chip } from "framework7-vue";
import Planificacion from "./../../js/db/Planificacion.js";

export default {
  components: {
    rForm,
    rInput,
    f7Chip
  },
  data() {
    return {
      Planificacion,
      id: this.$f7route.params.id,
      rformData: null,
      readonly: true
    };
  },
  methods: {
    loadItem(item) {
      this.rformData = item;
    },
    removeInspector(index) {
      if (this.readonly) return;
      const inspectores = this.$refs.rform && this.$refs.rform.formData && this.$refs.rform.formData.inspectores;
      if (inspectores && index >= 0 && index < inspectores.length) {
        inspectores.splice(index, 1);
      }
    }
  }
};
</script>
